import { render, staticRenderFns } from "./footer_m.vue?vue&type=template&id=3d8e9626&scoped=true"
import script from "./footer_m.vue?vue&type=script&lang=js"
export * from "./footer_m.vue?vue&type=script&lang=js"
import style0 from "./footer_m.vue?vue&type=style&index=0&id=3d8e9626&prod&scoped=true&lang=css"
import style1 from "./footer_m.vue?vue&type=style&index=1&id=3d8e9626&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e9626",
  null
  
)

export default component.exports